import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot } from '@angular/router';
import { catchError, map, type Observable, of } from 'rxjs';

import { DEV_SUBDOMAIN_OVERRIDE } from '@blaze-shared/platform-data-access';
import { urlUtils } from '@blaze-shared/platform-util';
import { ProjectsApiService } from '@blaze-shared/projects-data-access';

export function redirectOnCustomCname(
  _routeSnapshot: Partial<ActivatedRouteSnapshot>,
): Observable<string> | string {
  const projectsApiService = inject(ProjectsApiService);
  const devSubdomainOverride = inject(DEV_SUBDOMAIN_OVERRIDE);

  if (urlUtils.isDashboardUrl() || urlUtils.isPublishedMode()) {
    return 'projects';
  }
  const url = urlUtils.isLocalHostUrl()
    ? `https://${devSubdomainOverride}`
    : globalThis.location.href;
  return projectsApiService.getAppRedirectInfo(url).pipe(
    catchError((error) => {
      console.error('Unable to get app redirect info', error);
      return of(null);
    }),
    map((resp) => {
      if (resp && resp.shouldRedirect && resp.redirectUrl) {
        globalThis.location.href = resp.redirectUrl;
        return '';
      }
      return 'projects';
    }),
  );
}
